import {
  openPopupPromise,
  PopupDialogOrigin,
} from 'src/lib/popups/popupOpenClose';
import * as Level from 'src/replicant/level';
import StateObserver from 'src/StateObserver';
import { getTutorialController } from '../tutorial/TutorialController';
import { trackPinchConversion } from 'src/lib/analytics/events';

/**
 * Standard level up sequence. Will not be triggered if progression feature is enabled.
 * @returns
 */
export async function levelUpSequence(origin: PopupDialogOrigin | undefined) {
  const { user } = StateObserver.getState();

  const { level } = user;
  const levelDiff = level.current - level.lastLevelReward;

  if (!levelDiff) return;

  await openPopupPromise('popupLevelUPReward', {
    level: level.current + 1,
    reward: Level.ruleset.levelUpReward(
      level.current - levelDiff,
      level.current,
    ),
    origin,
  });

  // Claim rewards.
  await StateObserver.invoke.claimLevelRewards();

  trackPinchConversion({
    action: 'in_game',
    feature: 'player_level_up',
    subFeature: 'player_level_up',
    resource: 'gems',
  });

  // Trigger level-related tutorials
  await getTutorialController().handleEvent('levelIncreased');
}
